import getMediaURL from 'utils/getMediaURL'

const reduceMedias = medias => {
  return medias.reduce((filesMap, media) => {
    const { id, name, node, thumbnail, restriction, preview, addedAt } = media
    const extension = name.substring(name.lastIndexOf('.') + 1).toLowerCase()

    filesMap[id] = {
      id,
      name,
      preview: preview ? getMediaURL(preview) : null,
      thumbnail: thumbnail ? getMediaURL(thumbnail) : null,
      restrictionType: restriction.type,
      node,
      addedAt,
      extension: extension,
      hidden: false
    }
    return filesMap
  }, {})
}

export default reduceMedias



// WEBPACK FOOTER //
// ./src/utils/reduceMedias.js